import component from './component';

export default component;
export { component as Pagination };
